import { patterns } from '@gem/utils';

import { ISymbolsHandler } from '../../getSymbolsChecks.types';
import { getContentPositions } from '../../utils/getContentPositions/getContentPositions';
import { isLastDot } from './utils/isLastDot';
import { isValidDot } from './utils/isValidDot';

export const handlerLink: ISymbolsHandler = (opts) => {
  const { text, index, symbolMatches } = opts;

  if (!isValidDot(text, index)) {
    return;
  }

  if (!isLastDot(text, index)) {
    return;
  }

  const { startPosition, content } = getContentPositions(text, index);

  const matches = content.matchAll(new RegExp(patterns.AUTOLINK_WEB_URL, 'igu'));

  for (const link of matches) {
    const linkStartPos = startPosition + link.index;
    /* get markdown symbols before link in word */
    const beforeLinkMarks = Object.keys(symbolMatches).filter((mark) =>
      symbolMatches[mark].some((pos) => pos.end === linkStartPos)
    );
    /* if link has before markdown symbols, find this symbols and min symbol position after link in word */
    const minAfterLinkMarkPos = beforeLinkMarks.length
      ? Math.min(...beforeLinkMarks.map((mark) => link[0].indexOf(mark)))
      : -1;
    const linkEndPos =
      minAfterLinkMarkPos > 0 ? linkStartPos + minAfterLinkMarkPos : linkStartPos + link[0].length;

    symbolMatches['link'].push({
      start: linkStartPos,
      end: linkEndPos,
      link: minAfterLinkMarkPos > 0 ? link[0].slice(0, minAfterLinkMarkPos) : link[0],
    });
  }
};
